<template>
  <div>
    <DashboardAdminSekolah v-if="$store.getters['account/accountData'].role === 'admin-sekolah'"/>
    <DashboardSuperadmin v-else/>
  </div>
</template>
<script>
  import DashboardSuperadmin from "./DashboardSuperadmin.vue";
  import DashboardAdminSekolah from "./DashboardAdminSekolah.vue";

  export default {
    components: {
      DashboardSuperadmin,
      DashboardAdminSekolah
    }
  }
</script>